import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, NgZone, ApplicationRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { IWorkbookLogService } from '../../services/services';
import { Title } from '@angular/platform-browser';
import { Table } from 'primeng/table';
import { v4 as uuidv4 } from 'uuid';
import { Configuration, IVendorJobClient, WorkbookConfiguration, WorkbookConfigurationClient } from '../../services/nswag/nswagclient';

type MessageSeverity = 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast';

interface WorkbookMessage {
  severity: MessageSeverity;
  summary?: string;
  detail?: string;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'workbook',
    templateUrl: './workbook.component.html',
    styleUrls: ['./workbook.component.css'],
    standalone: false
})
export class WorkbookComponent implements OnInit, AfterViewInit {
  @ViewChild(Table) dataTable?: Table;

  dashboardLink = '';
  jobNumber = '';
  isEditorOrAdmin = false;
  workbookConfigurationReady = false;
  workbookLogsReady = false;
  workbookReady = false;
  everythingReady = false;
  workbookConfiguration: WorkbookConfiguration = new WorkbookConfiguration();
  workbookLogs: any[] = [];
  scrollableCols: any[] = [];
  frozenCols: any[] = [];
  scrollHeight = '500px';
  messages: WorkbookMessage[] = [];
  showWorkbookConfigurationDialog = false;
  availableFieldOptions: SelectItem[] = [];
  selectedAvailableField: string | null = null;
  createdField: string | null = null;
  createFieldIsText = false;
  createFieldWidth = '60%';
  createFieldIsTextWidth = '15%';
  createFieldButtonWidth = '25%';
  fieldNameWidth = '75%';
  buttonWidth = '25%';
  inputDate = new Date();
  changesMade = false;
  changedClientIds: string[] = [];
  showSavingProgress = false;
  savedRows = 0;
  fluidSystems: SelectItem[] = [
    { 'label': 'SLW', value: 'SLW' },
    { 'label': 'SWP', value: 'SWP' }
  ];
  activities: SelectItem[] = [
    { 'label': 'Actvity', value: 'Activity' },
    { 'label': 'Circulating', value: 'Circulating' },
    { 'label': 'Milling', value: 'Milling' },
    { 'label': 'OOH', value: 'OOH' },
    { 'label': 'OOH-END', value: 'OOH-END' },
    { 'label': 'Pickup', value: 'Pickup' },
    { 'label': 'POOH', value: 'POOH' },
    { 'label': 'RIH', value: 'RIH' },
    { 'label': 'RIH-Start', value: 'RIH-Start' },
    { 'label': 'Short Trip', value: 'Short Trip' },
    { 'label': 'Start POOH', value: 'Start POOH' },
    { 'label': 'Start ST', value: 'Start ST' }
  ];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    @Inject("IVendorJobClient") private _jobService: IVendorJobClient,
    private _workbookConfigurationService: WorkbookConfigurationClient,
    private _workbookLogService: IWorkbookLogService,
    private _titleService: Title,
    private _changeDetectorRef: ChangeDetectorRef,
    private _ngZone: NgZone,
    private _appRef: ApplicationRef
  ) {
    console.log('[Workbook] Constructor called');
  }

  ngOnInit() {
    console.log('[Workbook] ngOnInit called');
    this.getJobNumberFromRoute();
  }

  ngAfterViewInit() {
    console.log('[Workbook] ngAfterViewInit called');
    console.log('[Workbook] dataTable ViewChild:', this.dataTable);
    console.log('[Workbook] everythingReady in AfterViewInit:', this.everythingReady);
    
    // Force change detection check
    setTimeout(() => {
      console.log('[Workbook] Delayed check - everythingReady:', this.everythingReady);
      console.log('[Workbook] Delayed check - workbookLogs length:', this.workbookLogs?.length);
      console.log('[Workbook] Delayed check - frozenCols length:', this.frozenCols?.length);
      console.log('[Workbook] Delayed check - scrollableCols length:', this.scrollableCols?.length);
    }, 1000);
  }

  navigateToDashboard() {
    if (!this.jobNumber || this.jobNumber === 'New' || this.jobNumber === '') return;
    window.open(this.dashboardLink);
  }

  navigateToJobDetails() {
    if (!this.jobNumber || this.jobNumber === 'New' || this.jobNumber === '') return;
    const decodedJobId = decodeURIComponent(this.jobNumber);
    this._router.navigate(['/vendorjob/' + encodeURIComponent(decodedJobId)]);
  }

  navigateToShiftSummaries() {
    if (!this.jobNumber || this.jobNumber === 'New' || this.jobNumber === '') return;
    const decodedJobId = decodeURIComponent(this.jobNumber);
    this._router.navigate(['/vendorjob/' + encodeURIComponent(decodedJobId) + '/shiftsummaries']);
  }

  getJobNumberFromRoute() {
    console.log('[Workbook] getJobNumberFromRoute called');
    this._route.params.subscribe(params => {
      console.log('[Workbook] Route params:', params);
      this.jobNumber = params['id'];
      console.log('[Workbook] Job number extracted:', this.jobNumber);
      if (this.jobNumber == null || this.jobNumber === '') {
        console.error('[Workbook] Invalid JobNumber - null or empty');
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Invalid JobNumber',
          detail: 'A valid JobNumber must be passed as Url arguement'
        });
        console.error('Invalid JobNumber');
      } else {
        console.log('[Workbook] Valid job number, fetching data...');
        this.getWorkbookConfiguration();
        this.getWorkbookLogData();
        this._jobService.getDashboardLink(this.jobNumber).subscribe(r => {
          console.log('[Workbook] Dashboard link received:', r);
          this.dashboardLink = r;
        });
      }
      this.setPageTitle(this.jobNumber);
    });
  }

  setPageTitle(jobId: string) {
    if (!jobId || jobId === 'New' || jobId === '') {
      this._titleService.setTitle('New Job');
    } else { this._titleService.setTitle(jobId); }
  }

  getWorkbookConfiguration() {
    console.log('[Workbook] getWorkbookConfiguration called for job:', this.jobNumber);
    this._workbookConfigurationService.getJobConfiguration(this.jobNumber).subscribe(
      result => {
        console.log('[Workbook] Configuration received:', result);
        if (result == null) {
          console.log('[Workbook] No configuration found, using default');
          // If no workbook configuration data set, use default
          this.workbookConfiguration = new WorkbookConfiguration();
          this.workbookConfiguration.job_number = this.jobNumber;
          this.updateWorkbookConfiguration();
        } else {
          console.log('[Workbook] Configuration loaded successfully');
          this.workbookConfiguration = result;
        }
        this.ensureWorkbookConfigurationCollections();
        this.workbookConfigurationReady = true;
        console.log('[Workbook] workbookConfigurationReady set to true');
        this.checkIfCanBuildWorkbook();
      },
      error => {
        console.error('[Workbook] Error loading configuration:', error);
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Could not get Workbook Configuration',
          detail: 'Workbook Configuration data for JobNumber: ' + this.jobNumber + ' could not be loaded.'
        });
        console.error(error);
      }
    );
  }

  getWorkbookLogData() {
    console.log('[Workbook] getWorkbookLogData called for job:', this.jobNumber);
    this._workbookLogService.getWorkbookLogs(this.jobNumber).subscribe(
      result => {
        console.log('[Workbook] Workbook logs received:', result);
        this.workbookLogs = result;
        if (this.workbookLogs == null) { 
          console.log('[Workbook] Logs were null, initializing empty array');
          this.workbookLogs = []; 
        }
        console.log('[Workbook] Number of logs:', this.workbookLogs.length);

        // make sure data is sorted by date descending
        this.workbookLogs.sort((a, b) => {
          if (a.time == null || b.time == null) { return 0; }
          if (a.time < b.time) { return -1; } else if (a.time > b.time) { return 1; } else { return 0; }
        });

        this.workbookLogs.forEach(log => {
          log.calendarTime = new Date(log.time);
        });

        this.workbookLogsReady = true;
        console.log('[Workbook] workbookLogsReady set to true');
        this.checkIfCanBuildWorkbook();
      },
      error => {
        console.error('[Workbook] Error loading workbook logs:', error);
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Could not get Workbook Logs',
          detail: 'Workbook Log data for JobNumber: ' + this.jobNumber + ' could not be loaded.'
        });
        console.error(error);
      }
    );
  }

  setScrollHeight(): string  {
    console.log('[Workbook] setScrollHeight called, workbookLogs length:', this.workbookLogs?.length);
    if (!this.workbookLogs || this.workbookLogs.length < 1) {
      console.log('[Workbook] No logs, returning 0px');
      return '0px';
    }

    if (this.workbookLogs.length < 10) {
      const scrollHeightNumber = Math.floor(this.workbookLogs.length / 2) * 100;
      if (scrollHeightNumber === 0) {
        console.log('[Workbook] Calculated height is 0, returning 100px');
        return this.scrollHeight = '100px';
      }
      console.log('[Workbook] Returning calculated height:', scrollHeightNumber + 'px');
      return (scrollHeightNumber).toString() + 'px';
    }

    console.log('[Workbook] Returning default 500px');
    return '500px';
  }

  checkIfCanBuildWorkbook() {
    console.log('[Workbook] checkIfCanBuildWorkbook - configReady:', this.workbookConfigurationReady, 'logsReady:', this.workbookLogsReady);
    if (this.workbookConfigurationReady && this.workbookLogsReady) {
      console.log('[Workbook] Both ready, building workbook...');
      this.buildWorkbook();
    } else {
      console.log('[Workbook] Not ready yet to build workbook');
    }
  }

  buildWorkbook() {
    console.log('[Workbook] buildWorkbook called');
    this.ensureWorkbookConfigurationCollections();
    this.frozenCols = [];
    this.scrollableCols = [];
    // Always show time and relative_time in that order
    this.frozenCols.push({ field: 'time', header: 'Time', display: 'table-cell' });
    // this.scrollableCols.push({ field: "time", header: "Time" });
    // The scrollable 'time' column will be hidden in table but used for export
    this.scrollableCols.push({ field: 'time', header: 'Timestamp', display: 'none' });
    this.scrollableCols.push({ field: 'relative_time', header: 'Hours', display: 'table-cell' });
    this.scrollableCols.push({ field: 'comments', header: 'Comments', display: 'table-cell' });
    this.scrollableCols.push({ field: 'plug_number', header: 'Plug #', display: 'table-cell' });
    this.scrollableCols.push({ field: 'activity', header: 'Activity', display: 'table-cell' });
    this.scrollableCols.push({ field: 'depth', header: 'Depth (ft)', display: 'table-cell' });
    this.scrollableCols.push({ field: 'funnel_vis', header: 'Funnel Visc (s)', display: 'table-cell' });
    this.scrollableCols.push({ field: 'fluid_system', header: 'Fluid System', display: 'table-cell' });
    this.scrollableCols.push({ field: 'swp_vol_bbls', header: 'SWP Vol (bbl)', display: 'table-cell' });
    this.scrollableCols.push({ field: 'circulating_psi', header: 'Circulating PSI', display: 'table-cell' });
    this.scrollableCols.push({ field: 'wh_psi', header: 'WH PSI', display: 'table-cell' });
    this.scrollableCols.push({ field: 'called_pumped_bpm', header: 'Pump Rate-Called (BPM)', display: 'table-cell' });
    this.scrollableCols.push({ field: 'called_fb_bpm', header: 'Return Rate-Called (BPM)', display: 'table-cell' });

    console.log('[Workbook] Checking workbookConfiguration for displayFields');
    console.log('[Workbook] WorkbookConfiguration:', this.workbookConfiguration);
    
    // Show additional Fields to display based on configuration
    const displayFields = this.workbookConfiguration.displayFields ?? [];
    if (displayFields.length > 0) {
      console.log('[Workbook] Display fields:', displayFields);
      displayFields.forEach(fieldToDisplay => {
        // if(!this.cols.includes(fieldToDisplay)) {
        //   this.cols.push({ field: fieldToDisplay, header: fieldToDisplay });
        // }
        // Above doesn't work since default header columns have uppercase leading character
        if (fieldToDisplay !== 'time' && fieldToDisplay !== 'relative_time' && fieldToDisplay !== 'comments' &&
           fieldToDisplay !== 'plug_number' && fieldToDisplay !== 'activity' && fieldToDisplay !== 'depth' &&
           fieldToDisplay !== 'funnel_vis' && fieldToDisplay !== 'fluid_system' && fieldToDisplay !== 'swp_vol_bbls' &&
           fieldToDisplay !== 'circulating_psi' && fieldToDisplay !== 'wh_psi' && fieldToDisplay !== 'called_pumped_bpm' &&
           fieldToDisplay !== 'called_fb_bpm'
          ) {
          this.scrollableCols.push({ field: fieldToDisplay, header: fieldToDisplay, display: 'table-cell' });
        }
      });
    } else {
      console.warn('[Workbook] No displayFields found in configuration');
    }

    this.scrollHeight = this.setScrollHeight();
    console.log('[Workbook] Scroll height set to:', this.scrollHeight);

    // Add available fields to add to columns if they are not already displayed
    // (time, relative_time, and comments always shown.)
    this.availableFieldOptions = [];
    const availableFields = this.workbookConfiguration.availableFields ?? [];
    if (availableFields.length > 0) {
      console.log('[Workbook] Available fields:', availableFields);
      availableFields.forEach(field => {
        if (
          field !== 'time' &&
          field !== 'relative_time' &&
          field !== 'comments' &&
          field !== 'plug_number' &&
          field !== 'activity' &&
          field !== 'depth' &&
          field !== 'funnel_vis' &&
          field !== 'fluid_system' &&
          field !== 'swp_vol_bbls' &&
          field !== 'circulating_psi' &&
          field !== 'wh_psi' &&
          field !== 'called_pumped_bpm' &&
          field !== 'called_fb_bpm' &&
          !displayFields.includes(field)) {
            this.availableFieldOptions.push({ label: field, value: field });
          }
      });
    } else {
      console.warn('[Workbook] No availableFields found in configuration');
    }
    this.selectedAvailableField = null;

    this.createdField = null;
    this.createFieldIsText = false;
    this.workbookReady = true;
    console.log('[Workbook] workbookReady set to true');
    console.log('[Workbook] Frozen columns count:', this.frozenCols.length);
    console.log('[Workbook] Scrollable columns count:', this.scrollableCols.length);
    this.checkIfEvertythingIsReady();
  }

  checkIfEvertythingIsReady() {
    console.log('[Workbook] checkIfEvertythingIsReady - everythingReady:', this.everythingReady);
    console.log('[Workbook] - configReady:', this.workbookConfigurationReady);
    console.log('[Workbook] - logsReady:', this.workbookLogsReady);
    console.log('[Workbook] - workbookReady:', this.workbookReady);
    console.log('[Workbook] - workbookLogs array:', this.workbookLogs);
    console.log('[Workbook] - frozenCols:', this.frozenCols);
    console.log('[Workbook] - scrollableCols:', this.scrollableCols);
    
    // Run inside NgZone to ensure Angular's change detection picks up the changes
    this._ngZone.run(() => {
      this.everythingReady = this.workbookConfigurationReady && this.workbookLogsReady && this.workbookReady;
      console.log('[Workbook] Set everythingReady inside NgZone:', this.everythingReady);
      
      if (this.everythingReady) {
        console.log('[Workbook] Marking for check');
        this._changeDetectorRef.markForCheck();
        
        // Force full application tick
        console.log('[Workbook] Forcing application tick');
        this._appRef.tick();
        
        // Also try detectChanges as backup
        setTimeout(() => {
          console.log('[Workbook] Forcing detectChanges after timeout');
          this._changeDetectorRef.detectChanges();
        }, 0);
      }
    });
  }

  setWidth(col: any): string {
    const width = '75px';
    if (!col || !col.field) { return width; }

    // For some reason column width style applies to
    // column after the one being compared here???
    // if(col.field === "comments") return '250px';
    // if(col.field == "actvity") return '200px';
    if (col.field === 'relative_time') { return '215px'; }
    if (col.field === 'plug_number') { return '115px'; }

    return width;
  }

  openWorkbookConfiguration() {
    this.showWorkbookConfigurationDialog = true;
  }

  hideDisplayedField(fieldName: string) {
    const displayFields = this.workbookConfiguration.displayFields ?? [];
    this.workbookConfiguration.displayFields = displayFields.filter(field => field !== fieldName);
    this.buildWorkbook();
    this.updateWorkbookConfiguration();
  }

  displayField() {
    const displayFields = this.workbookConfiguration.displayFields ?? (this.workbookConfiguration.displayFields = []);
    if (
        this.selectedAvailableField != null &&
        this.selectedAvailableField !== '' &&
        !(displayFields.includes(this.selectedAvailableField))
      ) {
          displayFields.push(this.selectedAvailableField);
          this.buildWorkbook();
          this.updateWorkbookConfiguration();
    } else {
      this.messages = [];
      this.messages.push({
        severity: 'error',
        summary: 'Could not add ' + this.selectedAvailableField,
        detail: 'Field is either invalid or already displayed.'
      });
    }
  }

  createField() {
    const availableFields = this.workbookConfiguration.availableFields ?? (this.workbookConfiguration.availableFields = []);
    const displayFields = this.workbookConfiguration.displayFields ?? (this.workbookConfiguration.displayFields = []);
    const customFields = this.workbookConfiguration.customFields ?? (this.workbookConfiguration.customFields = []);
    if (
        this.createdField != null &&
        this.createdField !== '' &&
        !(availableFields.includes(this.createdField))
      ) {
        availableFields.push(this.createdField);
        displayFields.push(this.createdField);
        const configuration = new Configuration();
        configuration.isText = this.createFieldIsText;
        configuration.name = this.createdField;
        customFields.push(configuration);
        this.buildWorkbook();
        this.updateWorkbookConfiguration();
      } else {
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Could not create ' + this.createdField,
          detail: 'Field is either invalid or already exists.'
        });
      }
  }

  updateWorkbookConfiguration() {
    this._workbookConfigurationService.put(this.jobNumber, this.workbookConfiguration).subscribe(
      result => {},
      error => {
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Could not save Workbook Configuration changes.',
          detail: ''
        });
        console.error(error);
      }
    );
  }

  // When updating after cell has onEditComplete event is fired
  tableDataChanged(event: any) {
    this.updateWorkbookLog(event.data);
    this.buildWorkbook();
  }

  // When updating using Save button, this is called when a cell's
  // onEditInit event is fired
  notifyChangesMade(event: any) {
    if (event || event.data) {
      if (!(this.changedClientIds.includes(event.data.client_id))) {
        this.changedClientIds.push(event.data.client_id);
      }
    }
    this.changesMade = true;
  }

  // For updating single workbook row
  updateWorkbookLog(workbookLog: any, targetRows: number | null = null) {
    this._workbookLogService.updateWorkBookLog(workbookLog.client_id, workbookLog).subscribe(
      result => {},
      error => {
        this.messages = [];
        this.messages.push({
          severity: 'error',
          summary: 'Could not save Workbook Log update.',
          detail: ''
        });
        console.error(error);
      },
      () => {
        if (targetRows) {
          this.savedRows = this.savedRows + 1;
          this.setSaveProgress(targetRows);
        }
      });
  }

  addWorkbookLogRow() {
    this.workbookLogs.push(this.createNewWorkbookLog());
    this.dataTable?.reset();
    this.buildWorkbook();
  }

  createNewWorkbookLog(): { client_id: string; job_number: string; time: Date; calendarTime: Date; relative_time: number | null; [key: string]: unknown } {
    const time = new Date(Date.now());
    const workbookLog: { client_id: string; job_number: string; time: Date; calendarTime: Date; relative_time: number | null; [key: string]: unknown } = {
      'client_id' : uuidv4(),
      'job_number' : this.jobNumber,
      'time': time,
      'calendarTime': time,
      'relative_time': null // calculate here or done server side?
    };
    const availableFields = this.workbookConfiguration.availableFields ?? [];
    availableFields.forEach(field => {
      if (field !== 'time' && field !== 'relative_time') {
        workbookLog[field] = null;
      }
    });
    return workbookLog;
  }

  // setInputDate(currentTime: string) {
  //   this.inputDate = new Date(currentTime);
  // }

  // setTime(clientId: string) {
  //   const workBookLogToUpdate = this.workbookLogs.find(wl => wl.client_id === clientId);
  //   if (workBookLogToUpdate != null) {
  //     workBookLogToUpdate.time = this.inputDate;
  //   }
  // }

  // Called from savebutton, updates every row that had a changed recorded
  saveWorkbookChanges() {
    if (this.changedClientIds) {
      const targetRows = this.changedClientIds.length;
      this.changedClientIds.forEach(clientId => {
        const workbookLog = this.workbookLogs.find(w => w.client_id === clientId);
        if (workbookLog) {
          workbookLog.time = workbookLog.calendarTime;
          this.updateWorkbookLog(workbookLog, targetRows);
        }
      });
    }
    this.changedClientIds = [];
    this.changesMade = false;
  }

  setSaveProgress(targetRows: number) {
    if (this.savedRows < targetRows) {
      this.showSavingProgress = true;
    } else {
      this.showSavingProgress = false;
      this.savedRows = 0;
    }
  }

  private ensureWorkbookConfigurationCollections(): void {
    this.workbookConfiguration.availableFields ??= [];
    this.workbookConfiguration.displayFields ??= [];
    this.workbookConfiguration.customFields ??= [];
  }
}
